import React from 'react'
import Navbar from '../section/Navbar'
import { Outlet } from 'react-router-dom'

function Root() {
  return (
    <div>
        <Navbar />
        <main>
            <Outlet />
        </main>
    </div>
  )
}

export default Root